import { useState, useCallback } from "react";

const useUsedFields = () => {
  const [usedFields, setUsedFields] = useState<Set<string>>(new Set());

  const addUsedField = useCallback((field: string) => {
    setUsedFields((prev) =>
      prev.has(field) ? prev : new Set(prev).add(field)
    );
  }, []);

  const removeUsedField = useCallback((field: string) => {
    setUsedFields((prev) => {
      if (!prev.has(field)) {
        return prev;
      }
      const next = new Set(prev);
      next.delete(field);
      return next;
    });
  }, []);

  const resetUsedFields = useCallback(() => {
    setUsedFields(new Set());
  }, []);

  return { usedFields, addUsedField, removeUsedField, resetUsedFields };
};

export default useUsedFields;
